interface OrbLogoProps {
  size?: number;
  className?: string;
}

export function OrbLogo({ size = 24, className }: OrbLogoProps) {
  const id = 'orb-logo';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      style={{ overflow: 'visible' }}
    >
      <defs>
        <filter id={`${id}-glow-far`} x="-200%" y="-200%" width="500%" height="500%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
        <filter id={`${id}-glow-mid`} x="-150%" y="-150%" width="400%" height="400%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
        </filter>
        <filter id={`${id}-glow-near`} x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" />
        </filter>
      </defs>

      {/* Far purple glow — wide and soft */}
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="#7c3aed"
        opacity="0.5"
        filter={`url(#${id}-glow-far)`}
      />

      {/* Mid lavender glow */}
      <circle
        cx="12"
        cy="12"
        r="8"
        fill="#a78bfa"
        opacity="0.7"
        filter={`url(#${id}-glow-mid)`}
      />

      {/* Near white glow — bright halo tight around core */}
      <circle
        cx="12"
        cy="12"
        r="7"
        fill="#e9d5ff"
        opacity="0.8"
        filter={`url(#${id}-glow-near)`}
      />

      {/* Solid white core */}
      <circle cx="12" cy="12" r="5.5" fill="#fff" />
    </svg>
  );
}
